const pageVisibility = (function () {
  let prefixSupport;
  // 首字母大写
  const keyWithPrefix = (prefix, key) => {
    if (prefix !== '') {
      return prefix + key.slice(0, 1).toUpperCase() + key.slice(1);
    }
    return key;
  };
  // 兼容各个浏览器 是否支持此属性
  const isPageVisibilitySupport = (function () {
    let support = false;
    if (typeof window.screenX === 'number') {
      ['webkit', 'moz', 'ms', 'o', ''].forEach(function (prefix) {
        if (
          support == false &&
          document[keyWithPrefix(prefix, 'hidden')] != undefined
        ) {
          prefixSupport = prefix;
          support = true;
        }
      });
    }
    return support;
  })();

  const isHidden = () => {
    if (isPageVisibilitySupport)
      return document[keyWithPrefix(prefixSupport, 'hidden')];

    return undefined;
  };

  // 状态
  const visibilityState = () => {
    if (isPageVisibilitySupport)
      return document[keyWithPrefix(prefixSupport, 'visibilityState')];
    return undefined;
  };

  // 事件名称
  const evnName = `${prefixSupport}visibilitychange`;

  return {
    // 隐藏
    hidden: isHidden,
    // 状态
    visibilityState: visibilityState,
    // 监听
    visibilitychange: (fn) => {
      if (isPageVisibilitySupport && typeof fn === 'function') {
        return window.document.addEventListener(evnName, fn, false);
      }
      return null;
    },
    //销毁
    destory: (fn) => {
      if (isPageVisibilitySupport) {
        return window.document.removeEventListener(evnName, fn, false);
      }
      return null;
    },
  };
})();

export default pageVisibility;
